<div class="header">Site {{site?.name}}</div>

<div class="tree-details-container">


  <div class="tree">
    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
      <mat-nested-tree-node *matTreeNodeDef="let node">
        <div class="mat-tree-node">
          <button mat-icon-button disabled></button>
          <mat-icon class="tree-icon">
            @if (node.type=='site') {
              factory
            }
            @else if (node.type=='location') {
              home
            }
            @else if (node.type=='asset') {
              settings
            }
            factory
          </mat-icon>
          <span (click)="onNodeSelect(node)" [class.selected-location]="node === selectedNode">
            {{node.name}}
          </span>
        </div>
      </mat-nested-tree-node>

      <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
        <div class="mat-tree-node">
          <button mat-icon-button matTreeNodeToggle (click)="onNodeSelect(node)">
            <mat-icon class="tree-icon">
              {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
            </mat-icon>
          </button>
          <mat-icon class="tree-icon">
            @if (node.type=='site') {
              factory
            }
            @else if (node.type=='location') {
              home
            }
            @else if (node.type=='asset') {
              settings
            }
            factory
          </mat-icon>
          <span (click)="onNodeSelect(node)" [class.selected-location]="node === selectedNode">{{node.name}}</span>
        </div>
        <div [class.tree-invisible]="!treeControl.isExpanded(node)" role="group">
          <ng-container matTreeNodeOutlet></ng-container>
        </div>
      </mat-nested-tree-node>
    </mat-tree>
  </div>



  <div class="details-panel">
    <div class="details-header">
      @if (selectedNode?.type=='site')
      {
        <mat-icon class="header-icon">factory</mat-icon>&nbsp;{{'Site: ' + selectedNode?.underlyingSite?.name}}
      }
      @else if (selectedNode?.type=='location') {
        <mat-icon class="header-icon">home</mat-icon>&nbsp;{{'Location: ' + selectedNode?.underlyingLocation?.name}}
      }
      @else if (selectedNode?.type=='asset' && selectedNode?.underlyingAsset?.assetId!=null) {
        <mat-icon class="header-icon">settings</mat-icon>&nbsp;Asset:&nbsp;<a href='/asset/{{selectedNode?.underlyingAsset?.assetId}}'>{{selectedNode?.underlyingAsset?.assetId}}</a>
      }
      @else {
        Select element
      }
    </div>
    <div class="details-contents">

      <site-details *ngIf="selectedNode?.type=='site'" [site]="selectedNode?.underlyingSite"></site-details>
      <location-details *ngIf="selectedNode?.type=='location'"
        [location]="selectedNode?.underlyingLocation"></location-details>
      <asset-detail *ngIf="selectedNode?.type=='asset'" [asset]="selectedNode?.underlyingAsset"></asset-detail>

    </div>
  </div>
</div>